export const environment = {
  userCreationUrl: 'https://casabitodev.casabito.io/',
  production: false,
  workerUrl: 'https://profiloabitativodev.casabito.io/be/api/v1',
  model: 'claude-sonnet-5-5',
  // Budget massimo di output per generazione profili, inclusi i token di thinking.
  archMaxTokens: 128000,
  // Supabase: storico versioni dei prompt (anon key  pubblica per design).
  supabaseUrl: 'https://mcicyveoroowexpivuwu.supabase.co',
  supabaseAnonKey: 'sb_publishable_x_BX5faVn9-KelddLwyPLg_oCdqNBKL',
};
